import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import HowItWorksSection from 'components/prize-landing-pages/HowItWorksSection';
import React, { useEffect } from 'react';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import CardWithBackgroundImage from 'components/CardWithBackgroundImage';
import { ENTER_CTA_LINK } from 'utils/cta/CTA';

const WinAHomeRenovation = () => {
  const router = useRouter();
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/win-a-home-renovation-spotdif`;

  useEffect(() => {
    localStorage.setItem('promoCode', 'SPOTDIF_DISCOUNT');
  }, []);

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win A Home Renovation Worth £100k"
        description="Enter our weekly draw for the chance to win £100,000 to spend on any work that needs doing around the house!"
        url="https://www.daymade.co.uk/prizes/details/win-house-renovation"
        openGraph={{
          title: 'DAYMADE | Win A Home Renovation Worth £100k',
          description:
            'Enter our weekly draw for the chance to win £100,000 to spend on any work that needs doing around the house!',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <CardWithBackgroundImage
          imageDirectory="/prize-landing-pages/win-a-home-renovation-spotdif"
          imageFname="hero"
          alt="stylish living room with large circular mirror and several plants"
        >
          <img
            className="spotdifLogo"
            src={`${imageDirectory}/spotdif-logo.png`}
            alt="Spotdif logo"
          />
        </CardWithBackgroundImage>

        <GreenPageSection additionalClassName="pageTitleGreenSectionContainer">
          <Subheading Tag="h1" className="pageTitle">
            Win A Home Renovation
            <br />
            <span style={{ fontSize: '2em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>First entry free!</p>
          <RoundedButton href={ENTER_CTA_LINK} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div
            className="flexCentered flexRow"
            style={{ margin: '3em 1em 0', width: '100%', maxWidth: 450 }}
          >
            <a
              href="https://uk.trustpilot.com/review/daymade.co.uk"
              target="_blank"
              style={{ width: '35%' }}
            >
              <img
                src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`}
                style={{ width: '100%' }}
              />
            </a>
            <a
              href="https://www.veritree.com/"
              target="_blank"
              style={{
                marginLeft: '10%',
                width: '40%',
                display: 'flex',
                alignItems: 'center',
                textAlign: 'left',
                wordBreak: 'break-word',
                whiteSpace: 'break-spaces',
              }}
            >
              <img
                src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`}
                style={{ width: '25%', marginRight: '0.5em' }}
              />
              <span className="plantATreeText" style={{ maxWidth: '110px' }}>
                Plant a tree with every purchase
              </span>
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={
            <>
              Could You Be The Next <strong>Winner?</strong>
            </>
          }
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing various stylish rooms with modern designs"
        >
          <p>
            Have you been delaying that new floor, kitchen upgrade, roof work
            and house extension? This prize will help you get all of those jobs
            out of the way and the best thing is: you don't need to pay! With
            £100,000 in house renovation budget, we got you fully covered. Spend
            it on any house work that you've been dreaming about, and we (well,
            the builders) will get it done for you.
          </p>

          <div className="ctaContainer">
            <RoundedButton href={ENTER_CTA_LINK} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={
            <>
              What's <strong>Included?</strong>
            </>
          }
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="modern, recently refurbished kitchen dining area"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>£100,000 budget to spend on house renovations.</li>
          </ul>

          <div className="ctaContainer">
            <RoundedButton href={ENTER_CTA_LINK} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <HowItWorksSection
          whiteIcons
          onCtaClick={() => router.push(ENTER_CTA_LINK)}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection onCtaClick={() => router.push(ENTER_CTA_LINK)} />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />
      </PrizeLandingPage>

      <style jsx>
        {`
          @media (max-width: 400px) {
            .plantATreeText {
              font-size: 0.7em;
            }
          }

          .spotdifLogo {
            width: 50%;
            max-width: 300px;
            margin: 12% 0;
            background: white;
            padding: 4%;
            border-radius: 10px;
          }

          @media (min-width: 1000px) {
            .spotdifLogo {
              padding: 3%;
            }
          }
        `}
      </style>
    </MainLayout>
  );
};

export default WinAHomeRenovation;
